//
//
//
//
//
//

export default {
  name: 'waitReview'
}



// WEBPACK FOOTER //
// ./src/components/doctor/user/waitingReview.vue